import { Box,Text} from "@chakra-ui/react";
import { FaqHeaderWrapper } from "../styles";


const FAQHeaderSection: React.FC<FAQHeaderSectionProps> = ({
  title,
  subtitle,
}) => {
  return (
    <FaqHeaderWrapper>
      <Box>
        <Text fontSize="20px" fontWeight="700" color="#1E1E1E">
          {title}
        </Text>
        <Text fontSize="14px" fontWeight="400" color="#6B7280">
          {subtitle}
        </Text>
      </Box>
    </FaqHeaderWrapper>
  );
};

export default FAQHeaderSection;
